export default "__VITE_ASSET__BenUMBs6__"